export default "__VITE_ASSET__Cg$e8z0i__"